module.exports = __webpack_public_path__ + "static/media/futbol-regular.e6976c1e.svg";